import React from 'react';
import classNames from 'classnames';

class DropDownList extends React.Component {
  render() {
    const { props } = this;
    const styleNames = classNames('NewDropDown-list', {
      Animated: props.animated,
      dynamic: props.dynamic,
      'NewDropDown-list--dark': props.dark,
      // nested menu alignment
      'NewDropDown-list--top': props.alignment === 'top',
      'NewDropDown-list--bottom': props.alignment === 'bottom',
      [`Animated--${props.animation}`]: props.animated,
    });

    return (
      <ul ref="menu" style={props.style} className={styleNames}>
        {this.props.children}
      </ul>
    );
  }
}

DropDownList.defaultProps = {
  animated: true,
  animation: 'popDown',
};

export default DropDownList;
